import { render, staticRenderFns } from "./FreeMediaTypesDropdown.vue?vue&type=template&id=84fcead6&scoped=true&"
import script from "./FreeMediaTypesDropdown.vue?vue&type=script&lang=js&"
export * from "./FreeMediaTypesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FreeMediaTypesDropdown.vue?vue&type=style&index=0&id=84fcead6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fcead6",
  null
  
)

export default component.exports